import {RefundEnum} from 'presentation/constants';

export const SHOULD_RESET_PATHS: string[] = [
	RefundEnum.SENDING_DOCUMENTS,
	RefundEnum.REQUEST_PREVIEW,
	RefundEnum.REQUEST,
	RefundEnum.TERMS,
	RefundEnum.TERMS_PREVIEW,
	RefundEnum.TERMS_ADDITIONAL_DOCS,
];
